const config = {
  ApiGateway: 
  {
   Endpoint: process.env.REACT_APP_NADHEO_ENDPOINT
  },
  Cognito:
  {
    Region: "eu-west-1",
    UserPoolId: "eu-west-1_aSigjVkoc",
    AppClientId: "6fsrl74c2kvveimprs9o49ruja",
    IdentityPoolId: "eu-west-1:a7dc674f-c605-44c7-a4c4-5d05f2ea5485",
    Domain: "nadheo3.auth.eu-west-1.amazoncognito.com",
    RedirectSignIn: "https://after.nadheo.eu",
    RedirectSignOut: "https://after.nadheo.eu",
    OauthResponseType: "code",
    PwdFreeUserPoolId: "eu-west-1_k0qrUCrpz",
    PwdFreeAppClientId: "3029bv9184hn9j69uvrfubrm40"
  },
  Locize:
  {
    ProjectNamespace: "after2026"
  }
};

export default config;
